<template>
  <div style="min-height: 100px" v-loading="loading">
    <div v-if="surveyInfo">
      <el-card shadow="hover">
        <div style="padding: 10px">
          <warehouse-survey-info :surveyInfo="surveyInfo" />
          <div style="margin-top: 10px" v-if="surveyInfo.optStatus != 3">
            <el-button :size="$xUISize" @click="editClick" type="default">
              编辑
            </el-button>
            <el-button
              v-if="surveyInfo.inboundGoodsCount <= 0"
              :size="$xUISize"
              @click="cancelClick"
              type="danger"
            >
              取消
            </el-button>
          </div>
        </div>
      </el-card>
      <div>
        <x-tab v-model="tabName" :tabs="tabs" :query="tabParams" :params="tabParams" />
      </div>
    </div>
    <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
      <el-button v-if="errorMsg" @click="getDetail" size="small"> 重新加载 </el-button>
    </el-empty>
  </div>
</template>

<style lang="less" scoped>
.survey-detail {
  margin-top: 20px;
}
</style>

<script>
import warehouseSurveyInfo from "@/components/business/warehouseSurveyInfo.vue";
import surveyFromPage from "./__arranged_survey_form.vue";
import detailItemList from "./__arranged_survey_item_list.vue";

export default {
  components: {
    warehouseSurveyInfo,
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    tabParams() {
      if (!this.surveyInfo) {
        return {};
      }
      return {
        guid: this.surveyInfo.guid,
        surveyGuid: this.surveyInfo.guid,
        storeGuid: this.surveyInfo.storeGuid,
      };
    },
    tabs() {
      if (!this.surveyInfo) {
        return [];
      }
      let tabList = [
        {
          name: "survey-item-list",
          label: "调研清单",
          component: detailItemList,
          interval: true,
        },
      ];
      return tabList;
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      surveyInfo: null,
      printLoading: false,
      cancelLoading: false,
      tabName: "",
    };
  },
  methods: {
    editClick() {
      if (!this.surveyInfo) {
        return;
      }
      this.$drawer.openDrawer({
        title: "编辑调研单信息",
        refresh: () => {
          this.$drawer.refreshDrawer();
          this.getDetail();
        },
        component: surveyFromPage,
        params: {
          guid: this.surveyInfo.guid,
          storeGuid: this.surveyInfo.storeGuid,
        },
      });
    },
    surveyClick() {
      if (!this.surveyInfo) {
        return;
      }
      this.$confirm("确认标记为已调研？", "确认", {
        type: "info",
      }).then(() => {
        this.requestApi(
          "biz.warehouse.survey.info.survey",
          {
            guid: this.surveyInfo.guid,
          },
          {
            showError: true,
          }
        ).then(() => {
          this.$drawer.refreshDrawer();
          this.getDetail();
        });
      });
    },
    confirmedClick() {
      this.$confirm("确认要货，确认后将通知调研？", "确认", {
        type: "info",
      }).then(() => {
        this.requestApi(
          "biz.warehouse.survey.info.confirmed",
          {
            guid: this.surveyInfo.guid,
            storeGuid: this.surveyInfo.storeGuid,
          },
          {
            showError: true,
          }
        ).then(() => {
          this.$drawer.refreshDrawer();
          this.getDetail();
        });
      });
    },
    cancelClick() {
      if (!this.surveyInfo) {
        return;
      }
      this.$confirm("确认取消当前调研单？", "确认", {
        type: "error",
      }).then(() => {
        this.requestApi(
          "biz.warehouse.survey.info.cancel",
          {
            guid: this.surveyInfo.guid,
          },
          {
            showError: true,
          }
        ).then(() => {
          this.$drawer.refreshDrawer();
          this.getDetail();
        });
      });
    },
    getDetail() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.errorMsg = null;
      this.surveyInfo = null;
      return this.requestApi("biz.warehouse.survey.info.detail", {
        guid: this.pageParams.guid,
        storeGuid: this.pageParams.storeGuid,
      })
        .then((resp) => {
          this.surveyInfo = resp.data;
        })
        .catch((err) => {
          this.errorMsg =
            (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.tabName = this.pageParams.tabName;
    this.getDetail();
  },
};
</script>
